import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBell, cilEnvelopeOpen, cilList, cilMenu,cilAccountLogout } from '@coreui/icons'
import { API_ENDPOINT } from '../environment'

import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './header/index'
import { logo } from 'src/assets/brand/logo'
import { authService } from "../services/auth.service";
import { sygnet } from 'src/assets/brand/sygnet'

const AppHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  // let logout = () => {
  //   authService.signout();

  // }
  return (
    <CHeader position="sticky" className="mb-4 rt-header">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          <CIcon icon={API_ENDPOINT+authService.userInfo().avatar} height={48} alt="Logo" />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <CNavLink to="/dashboard" component={NavLink} activeClassName="active">
              <h1>Dashboard</h1>
            </CNavLink>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav>
          <CNavItem>
            <CNavLink to='/profile' component={NavLink} className='pointer'>
              <div className='rt-themecardbox'>
                <figure className='rt-roundimage'>
                <img src={authService.userInfo().avatar} alt="" height={40} />
                {/* <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} /> */}
                </figure>
                <div className='rt-themecontent'>
                  <h4>{authService.userInfo().name}</h4>
                </div>
              </div>
            </CNavLink>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          {/*<AppHeaderDropdown />*/}
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
